import React, { memo, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import InformationCard from '../../../../../../../shared/components/InformationCard';
import CustomSkeleton from './subComponents/CustomSkeleton';
const defaultFilters = {
    full_owner: 1
}

const Vehicle = ({
    idGpsDevices,
    getVehicleRequest,
    setVehicle,
    vehicles: { vehicle, fetching }
}) => {
    const { t } = useTranslation(["home", "devices", "vehicles"]);
    const vehicleOptions = useMemo(() => ([
        {
            label: `${t("vehicles:plate")}:`,
            value: vehicle.plate
        },
        {
            label: `${t("vehicles:brand")}:`,
            value: vehicle.brand
        },
        {
            label: `${t("vehicles:model")}:`,
            value: vehicle.model
        },
        {
            label: `${t("vehicles:chassis")}:`,
            value: vehicle.chassis || "-"
        },
        {
            label: `${t("vehicles:type")}:`,
            value: vehicle.type
        },
        {
            label: t("vehicles:remote_lock"),
            value: t(`devices:${vehicle.locking_enabled ? "yes" : "no"}`)
        }
    ]), [vehicle, t]);

    useEffect(() => {
        if (idGpsDevices) {
            getVehicleRequest({
                ...defaultFilters,
                gps: idGpsDevices
            });
        }
    }, [getVehicleRequest, idGpsDevices])

    useEffect(() => {
        return () => {
            setVehicle();
        }
    }, [setVehicle]);

    return (
        <>
            {
                (fetching || Object.keys(vehicle).length > 0) &&
                <InformationCard
                    title={t("home:vehicle")}
                    options={vehicleOptions}
                    loading={fetching}
                    customSkeleton={<CustomSkeleton />}
                    flexDirectionOption="column"
                    row
                />
            }
        </>
    );
};

export default memo(Vehicle);
